<template>
  <div class="change-password-dialog">
    <el-dialog append-to-body :title="row ? '修改角色' : '新增角色'" :visible="isShow" :close-on-click-modal="false" @close="closeDialog" width="500px">
      <el-form size="medium" class="form" :model="vForm" ref="vForm" label-width="80px" auto-complete="off">
        <el-form-item label="角色名称" class="form-group" prop="name" :rules="{ required: true, message: '角色名称必填' }">
          <el-input type="text" class="form-control" v-model="vForm.name" />
        </el-form-item>
        <el-form-item label="小程序" class="form-group" prop="shop_id" :rules="{ required: true, message: '小程序必选' }">
          <el-select v-loading="wxLoading" v-model="vForm.shop_id" placeholder="请选择" style="width: 100%">
            <el-option v-for="item in wxList" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型" class="form-group" prop="type">
          <el-radio v-model="vForm.type" :label="1">运营方</el-radio>
          <el-radio v-model="vForm.type" :label="2">观察者</el-radio>
        </el-form-item>
        <el-form-item label="角色描述" class="form-group">
          <el-input type="text" class="form-control" v-model="vForm.remark" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog" size="small">取 消</el-button>
        <el-button type="primary" @click="doSubmit" :loading="doSubmitLoading" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ['isShow', 'addEditType', 'row'],
  data() {
    return {
      doSubmitLoading: false,
      vForm: {
        id: '',
        name: '',
        type: 1,
        remark: '',
        shop_id: '',
        origin_type: 2,
      },
      wxLoading: false,
      wxList: [],
    };
  },
  created() {
    this.getWxList();
    if (this.row) {
      for (let key in this.vForm) {
        this.vForm[key] = this.row[key];
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('update:isShow', false);
    },

    async getWxList() {
      this.wxLoading = true;
      try {
        let res = await this.api.shop.lists();
        this.wxList = res.data;
      } catch (e) {
        console.error(e);
      }
      this.wxLoading = false;
    },

    doSubmit() {
      this.$refs.vForm.validate(async (valid) => {
        if (valid) {
          this.doSubmitLoading = true;
          try {
            let res = await this.api.userAdmin[this.row ? 'editRole' : 'addRole'](this.vForm);
            this.$message.success(res.message);
            this.closeDialog();
            this.$emit('success', this.row ? '' : 1);
          } catch (ex) {
            console.error(ex);
          }
          this.doSubmitLoading = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
